module.exports = require("qs");


//////////////////
// WEBPACK FOOTER
// external "qs"
// module id = 74
// module chunks = 0